export const SlideUpdateAlertConstant = {
    SLIDE_UPDATE_INITIATED : "SLIDE_UPDATE_INITIATED",
    SLIDE_UPDATE_SUCCESS : "SLIDE_UPDATE_SUCCESS",
    SLIDE_UPDATE_FAILED : "SLIDE_UPDATE_FAILED"
} 


